function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { providers } from 'ethers';
import { d as defaultAlchemyId } from '../../../dist/rpcs-b73a8f60.esm.js';

function alchemyProvider() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$alchemyId = _ref.alchemyId,
      alchemyId = _ref$alchemyId === void 0 ? defaultAlchemyId : _ref$alchemyId,
      pollingInterval = _ref.pollingInterval,
      priority = _ref.priority,
      stallTimeout = _ref.stallTimeout,
      weight = _ref.weight;

  return function (chain) {
    if (!chain.rpcUrls.alchemy) return null;
    return {
      chain: _objectSpread(_objectSpread({}, chain), {}, {
        rpcUrls: _objectSpread(_objectSpread({}, chain.rpcUrls), {}, {
          "default": "".concat(chain.rpcUrls.alchemy, "/").concat(alchemyId)
        })
      }),
      provider: function provider() {
        var provider = new providers.AlchemyProvider(chain.id, alchemyId);
        if (pollingInterval) provider.pollingInterval = pollingInterval;
        return Object.assign(provider, {
          priority: priority,
          stallTimeout: stallTimeout,
          weight: weight
        });
      },
      webSocketProvider: function webSocketProvider() {
        return new providers.AlchemyWebSocketProvider(chain.id, alchemyId);
      }
    };
  };
}

export { alchemyProvider };